import React from "react";
import { Progress } from 'antd';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
  } from 'chart.js';
  import { Line } from 'react-chartjs-2';
import TokenHistory from "../TokenHistory";
import "./TokenStatics.scss";
import { Button } from "../../UI";

export const TokenStatics = ({ token }) => {
  return (
    <div className="token_statics_container">
      <div className="analiics_container">
        <TokenChart token={token}/>
        <TokenProtocol token={token} />
      </div>

      <div>
        <TokenHistory />
      </div>
    </div>
  );
};

export const TokenProtocol = ({ token }) => {
  return (
    <>
      <div className="token_protocol_container">
        <div className="token_protocol_header">
          <div>
            <img src={token.logoURI} alt="logo" />
            <h2>{token.symbol}</h2>
          </div>
          <div>
            <p>TVL</p>
            <h3>700,000</h3>
          </div>
        </div>
        <div className="protocol_bar">
            <h2>{token.symbol} in Protocol</h2>
            <div className="lables">   <p>Available</p> <p>Utilized</p></div>
            <Progress strokeColor='#2B6DEF' percent={50} showInfo={false} className="progress_bar"/>
            <div className="lables small">   <p>150,000 (30%)</p> <p>550,000 (50%)</p></div>
        </div>
        <div className="lend_borrow_container">
           <div className="lend">
            <h3>Lend</h3>
            <div><p>Highest Lend APY</p> <p>30%</p></div>
            <div><p>Past 30D Avg.</p> <p>24%</p></div>
           </div>
           <div className="borrow">
            <h3>Borrow</h3>
            <div><p>Highest Borrow APY</p> <p>30%</p></div>
            <div><p>Past 30D Avg.</p> <p>24%</p></div>
           </div>

        </div>
        <div className="percentage_container">
            <div>
                <p>Lend APY</p>
                <h3>75.00%</h3>
            </div>
            <div>
                <p>Utilization rate</p>
                <h3>75.00%</h3>
            </div>
            <div>
                <p>Health Factor</p>
                <h3>75.00%</h3>
            </div>

        </div>
        <div className="total">
           <div><p>No. of Suppliers</p> <p>75.00%</p></div>
           <div><p>No. of Borrowers</p><p>75.00%</p></div>
        </div>
      </div>
    </>
  );
};

export const TokenChart = ({token}) => {
    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Filler,
      );
       const options = {
        responsive: true,
        maintainAspectRatio: false
      };
      
      const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
      
     const data = {
        labels,
        datasets: [
          {
            fill: true,
            data: labels.map(() => Math.random(10) * 100),
            borderColor: '#B4F7FD',
            backgroundColor: '#B6FBFF',
          },
        ],
      };
  return (
    <>
      <div className="token_chart_container">
      <div className="token_chart_header">
            <img src={token.logoURI} alt="logo" />
            <h2>{token.symbol}</h2>
        </div>
        <div className="chart_content">
        <Line width={10} height={10} options={options} data={data} />
        </div>
        <div className="chart_buttons">
         <Button className="style-active scale">TVL</Button>
         <Button className="white scale">Price</Button>
         <Button className="white scale">Utilization</Button>
        </div>
      </div>
    </>
  );
};
